import gql from 'graphql-tag';

export const getAvailableBusinessUnits = gql`
  query getAvailableBusinessUnits {
    getAvailableBusinessUnits {
      id
      name
    }
  }
`;
